import { useEffect, useContext } from "react";
import { Box, Button } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { BranchOrderRead } from "../../../global/API";
import { ToolContext } from "../../../../../core/context/ToolContext";

import { FeatureIdState } from "../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../global/API";


export const Generate = () => {
    const {tool_state, report_state, global_component_state} = useContext(ToolContext)
    const {__SESSION} = tool_state
    const {form, generateForm, branchOrderData} = report_state
    const {snackBarLoader} = global_component_state
    const tool_id =  process.env.REACT_APP_TID_BIZ;


    const handleGenerate = async() => {
        branchOrderData.set([])
        __generateData(0)
    }

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}->1`,
            feature_id: 1,
            feature_name: "branch-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }

    const __generateData = async(offset) => {
        if (form.data.to === '' || form.data.from === '' || form.data.to < form.data.from) {
            snackBarLoader.set({...snackBarLoader.data, snackbar:true, msg: `Invalid Date!`, type: "error"})
            return
        }else{
            generateForm.set((prev) => ({...prev, infiniteLoad:true}))
        }
        let qsp = {
            branch_id:form.data.branch_id,
            company_id:__SESSION.data.uaccess[0].company_id,
            user_id:form.data.user_id,
            from:form.data.from,
            to:form.data.to,
            limit:generateForm.data.limit,
            offset:offset   
        }

        let res = await BranchOrderRead(qsp)
        SendFeatureLogs()
        if (res) {
            if (res.length === 0) {
                branchOrderData.set(res)
                generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
                return
            } else {
                ///// LOADER VALIDATION
                if (res.length < generateForm.data.limit) {
                    branchOrderData.set((prev) => [...prev, ...res])
                    return
                } else {
                    generateForm.set((prev) => ({...prev, offset: res.length + branchOrderData.data.length}))
                }

                ///// STATE LIST DATA
                branchOrderData.set((prev) => [...prev, ...res])
            }   
        }
    }

    useEffect(() => {
        if (generateForm.data.offset !== 0) {
            __generateData(generateForm.data.offset)
        }else{
            generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
        }
        //eslint-disable-next-line
    }, [branchOrderData.data])

    return (
        <Box minHeight="55px" display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            <Box id="walkthrough-branch-sales-report-step-5" onClick={handleGenerate} component={Button} disableFocusRipple={true} minHeight="50px" minWidth="130px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<SyncIcon/>}>
                <Box fontSize={16} fontWeight={400} lineHeight="19px">Generate</Box>
            </Box>
        </Box>
    )
}